import { Injectable } from '@angular/core';
import {
  BuiltInPageItemDataService,
  InstalledAppsPageItemDataService,
  RecentlyWatchedTvPageItemDataService,
  TopTenLiveTvPageItemDataService,
  OtherAppsPageItemDataService,
  VodContentPageItemDataService,
  RecommendedAppsPageItemDataService,
  CurrentlyOnTvPageItemDataService,
  SpotlightPageItemDataService,
  SearchTagsPageItemDataService,
  UpcomingLiveTvPageItemDataService,
  FullscreenPageItemDataService,
  BannersCtaPageItemDataService,
  TvChannelLogoPageItemDataService,
  TopTenVodContentPageItemDataService,
  BannersPageItemDataService,
  CollectionsPageItemDataService,
  ChannelSpecificUpcomingPageItemDataService,
  RecommendationPageItemDataService,
  RecommendedChannelsPageItemDataService,
  MarketingBannerPageItemDataService,
  TvSeasonPageItemDataService,
  SeasonPageItemDataService,
  MarketingEmailBlockerPageItemDataService,
  MarketingSpotlightCtaPageItemDataService,
  GenrePageItemDataService,
  StudioPageItemDataService,
  CarouselPageItemDataService,
  MarketingHeroPageItemDataService,
  MarketingFaqPageItemDataService,
  MarketingPartnerVoucherPageItemDataService,
  MarketingRedeemCtaPageItemDataService,
  MarketingBulletedUspPageItemDataService,
  MarketingDetailPageItemDataService,
  MarketingDeviceCtaPageItemDataService,
  MarketingPageItemUspDataService,
  MarketingTargetedFaqPageItemDataService,
  HeroDataService,
  MarketingGenericVoucherPageItemDataService,
  CreateMarketingTargetedFaqPageItemApiModel,
  MarketingAppLandingPageItemDataService,
  MarketingPageItemKidsDataService,
  MarketingPageItemStudioDataService,
  MarketingPageItemTrendingDataService,
  MarketingPageItemEmailDataService,
  MarketingPageItemCtaDataService,
  ChannelSpecificCatchUpPageItemDataService,
  CatchUpPageItemDataService,
  MarketingPageItemVideoDataService,
  MarketingPageItemBarDataService,
  LandscapePageItemDataService,
  CategoryPageItemDataService,
  OndemandBannerPageItemDataService,
} from '@cxb/editor-stb-api';
import { Observable } from 'rxjs';
import { PageItem } from '../domain/page-item';
import { PageType } from '../page-edit-screen/page-type';
import { Tenant } from '../domain/tenant';

import { mapDomainGenreTrayToApi, mapDomainStudiosTrayToApi } from './components/generic-tray-form/generic-tray-form.mapping';
import { mapDomainCtaToApi } from './components/marketing-cta-tray-form/marketing-cta-tray-form.mapping';
import { mapDomainUspToApi } from './components/marketing-usp-tray-form/marketing-usp-tray-form.mapping';
import { mapDomainMarketingHeroToApi } from './components/marketing-hero-tray-form/marketing-hero-tray-form.mapping';
import { mapDomainDetailedPageMarketingBannerToApiModel } from './components/detailed-page-marketing-banner-form/detailed-page-marketing-banner-form.mapper';
import { mapDomainRedeemPartnerVoucherTrayToApi } from './components/redeem-partner-voucher-tray-form/redeem-partner-voucher-tray-form.mapping';
import { mapDomainRedeemGenericVoucherTrayToApi } from './components/redeem-generic-voucher-tray-form/redeem-generic-voucher-tray-form.mapping';
import { mapDomainRedeemUspTrayToApi } from './components/redeem-usp-tray-form/redeem-usp-tray-form.mapping';
import { mapCommonTrayDomainModelToApiModel } from './components/common-tray-form/common-tray-form.mapping';
import { mapDomainCollectionTrayToApi } from './components/collection-tray-form/collection-tray-form.mapping';
import { mapDomainFaqTrayToApi } from './components/faq-tray-form/faq-tray-form.mapping';
import { mapSeasonTrayDomainModelToApiModel } from './components/season-tray-form/season-tray-form.mapping';
import { mapSinglePhotoSeasonTrayDomainModelToApiModel } from './components/single-photo-season-tray-form/single-photo-season-tray-from.mapping';
import { mapHeroSpotlightTrayDomainModelToApiModel, mapHeroTrayDomainModelToApiModel } from './components/hero-editor/hero-editor.mapping';
import { mapRecommendationTrayDomainModelToApiModel } from './components/recommendation-tray-form/recommendation-tray-form.mapping';
import { mapTitleImagePortraitTrayDomainModelToApiModel } from './components/title-image-portrait-tray-form/title-image-portrait-tray-form.mapping';
import { mapStreamingContentTrayDomainModelToApiModel } from './components/streaming-content-tray-form/streaming-content-tray-form.mapping';
import { mapCurrentlyOnTVTrayDomainModelToApiModel } from './components/currently-on-tv-tray-form/currently-on-tv-tray-form.mapping';
import { mapChannelLogoTrayDomainModelToApiModel } from './components/channel-logo-tray-form/channel-logo-tray-form.mapping';
import { mapTopTenOnOSNPlusPosterArtTrayDomainModelToApiModel } from './components/top-ten-on-osn-plus-poster-art-tray-form/top-ten-on-osn-plus-poster-art-tray-form.mapping';
import { mapTopTenOnLiveTVTrayDomainModelToApiModel } from './components/top-ten-on-live-tv-tray-form/top-ten-on-live-tv-tray-form.mapping';
import { mapRecentlyWatchedTVTrayDomainModelToApiModel } from './components/recently-watched-tv-tray-form/recently-watched-tv-tray-form.mapping';
import {
  mapAppsAndGamesInstalledAppsTrayDomainModelToApiModel,
  mapAppsAndGamesRecommendedAppsTrayDomainModelToApiModel,
} from './components/apps-and-games-tray-form/apps-and-games-tray-form.mapping';
import { mapSearchTagsTrayDomainModelToApiModel } from './components/search-tags-tray/search-tags-tray.mapping';
import { mapComingSoonForLiveTvTrayDomainModelToApiModel } from './components/coming-soon-for-live-tv-tray/coming-soon-for-live-tv-tray.mapping';
import { mapFullscreenTrayDomainModelToApiModel } from './components/fullscreen-tray-form/fullscreen-tray-form.mapping';
import { mapBannersTrayWithCtaTrayDomainModelToApiModel } from './components/banners-tray-with-cta/banners-tray-with-cta.mapping';
import { mapNewCarouselTrayDomainModelToApiModel } from './components/new-carousel-tray-form/new-carousel-tray-form.mapping';
import { mapCarouselBannerTrayDomainModelToApiModel } from './components/carousel-banner-tray-form/carousel-banner-tray-form.mapping';
import { mapUpcomingOnSpecificTvChannelTrayDomainModelToApiModel } from './components/upcoming-on-specific-tv-channel-tray-form/upcoming-on-specific-tv-channel-tray-form.mapping';
import { mapRecommendedChannelsTrayDomainModelToApiModel } from './components/recommended-channels-tray/recommended-channels-tray.mapping';
import { mapMarketingBannerTrayDomainModelToApiModel } from './components/marketing-banner-tray-form/marketing-banner-tray-form.mapping';
import { mapMarketingEmailBlockerTrayDomainModelToApiModel } from './components/marketing-email-blocker-tray-form/marketing-email-blocker-tray-form.mapping';
import { mapSpotlightTrayDomainModelToApiModel } from './components/spotlight-tray-form/spotlight-tray-form.mapping';
import { mapDomainDeviceModuleTrayToApi } from './components/device-module-tray-form/device-module-tray-form.mapping';
import { mapDomainKidsToApiModel } from './components/marketing-kids-tray-form/marketing-kids-tray-form.mapping';
import { mapDomainTrendingToApi } from './components/marketing-trending-tray-form/marketing-trending-tray-form.mapping';
import { mapDomainStudioToApi } from './components/marketing-studio-tray-form/marketing-studio-tray-form.mapping';
import { mapDomainEmailCollectorToApi } from './components/marketing-email-collector-tray-form/marketing-email-collector-tray-form.mapping';
import {
  mapCatchUpTrayDomainToApiModel,
  mapChannelSpecificCatchUpTrayDomainToApiModel,
} from './components/catch-up-tray/catch-up-tray.mapping';
import { mapDomainRedeemCtaTrayToApi } from './components/redeem-cta-tray-form/redeem-cta-tray-form.mapping';
import { mapAppLandingPageItemDomainModelToApiModel } from './components/app-landing-mobile-tray-form/app-landing-mobile-tray-form.mapping';
import { mapBuiltInTrayDomainModelToApiModel, mapDomainBuiltInToApi } from './components/built-in-tray-form/built-in-tray-form.mapping';
import { mapMarketingVideoTrayDomainModelToApiModel } from './components/marketing-video-tray-form/marketing-video-tray.mapping';
import { mapMarketingBarTrayDomainModelToApiModel } from './components/marketing-bar-tray/marketing-bar-tray-mapping';
import { mapLandscapeTrayDomainModelToApiModel } from './components/landscape-tray-form/landscape-tray-form.mapping';
import { mapCategoryTrayDomainModelToApiModel } from './components/category-tray-form/category-tray-form.mapping';
import { mapOndemandBannerTrayDomainModelToApiModel } from './components/ondemand-banner-tray-form/ondemand-banner-tray-form.mapping';

@Injectable({ providedIn: 'root' })
export class TrayApiUpdateService {
  constructor(
    private readonly marketingHeroDataService: MarketingHeroPageItemDataService,
    private readonly marketingDetailPageItemDataService: MarketingDetailPageItemDataService,
    private readonly uspDataService: MarketingPageItemUspDataService,
    private readonly marketingCtaDataService: MarketingPageItemCtaDataService,
    private readonly carouselDataService: CarouselPageItemDataService,
    private readonly redeemPartnerVoucherTrayDataService: MarketingPartnerVoucherPageItemDataService,
    private readonly redeemGenericVoucherTrayDataService: MarketingGenericVoucherPageItemDataService, // AXB-1175
    private readonly redeemCtaTrayDataService: MarketingRedeemCtaPageItemDataService,
    private readonly redeemUspTrayDataService: MarketingBulletedUspPageItemDataService,
    private readonly faqTrayDataService: MarketingFaqPageItemDataService,
    private readonly targetedFaqTrayDataService: MarketingTargetedFaqPageItemDataService,
    private readonly seasonTrayDataService: TvSeasonPageItemDataService,
    private readonly singlePhotoSeasonTrayDataService: SeasonPageItemDataService,
    private readonly genrePageItemDataService: GenrePageItemDataService,
    private readonly studioPageItemDataService: StudioPageItemDataService,
    private readonly builtInDataService: BuiltInPageItemDataService,
    private readonly installedAppsPageItemDataService: InstalledAppsPageItemDataService,
    private readonly recommendedAppsPageItemDataService: RecommendedAppsPageItemDataService,
    private readonly otherAppsDataService: OtherAppsPageItemDataService,
    private readonly topTenVodContentPageItemDataService: TopTenVodContentPageItemDataService,
    private readonly recentlyWatchedTvPageItemDataService: RecentlyWatchedTvPageItemDataService,
    private readonly topTenLiveTvPageItemDataService: TopTenLiveTvPageItemDataService,
    private readonly currentlyOnTvPageItemDataService: CurrentlyOnTvPageItemDataService,
    private readonly spotlightPageItemDataService: SpotlightPageItemDataService,
    private readonly marketingBannerPageItemDataService: MarketingBannerPageItemDataService,
    private readonly searchTagsPageItemDataService: SearchTagsPageItemDataService,
    private readonly tvChannelLogoPageItemDataService: TvChannelLogoPageItemDataService,
    private readonly vodContentPageItemDataService: VodContentPageItemDataService,
    private readonly upcomingLiveTvPageItemDataService: UpcomingLiveTvPageItemDataService,
    private readonly fullscreenPageItemDataService: FullscreenPageItemDataService,
    private readonly bannersCtaPageItemDataService: BannersCtaPageItemDataService,
    private readonly bannersPageItemDataService: BannersPageItemDataService,
    private readonly collectionsPageItemDataService: CollectionsPageItemDataService,
    private readonly channelSpecificUpcomingPageItemDataService: ChannelSpecificUpcomingPageItemDataService,
    private readonly recommendationPageItemDataService: RecommendationPageItemDataService,
    private readonly recommendedChannelsPageItemDataService: RecommendedChannelsPageItemDataService,
    private readonly marketingEmailBlockerPageItemDataService: MarketingEmailBlockerPageItemDataService,
    private readonly spotlightTrayDataService: MarketingSpotlightCtaPageItemDataService,
    private readonly deviceModuleTrayDataService: MarketingDeviceCtaPageItemDataService,
    private readonly heroDataService: HeroDataService,
    private readonly appLandingPageItemDataService: MarketingAppLandingPageItemDataService,
    private readonly kidsDataService: MarketingPageItemKidsDataService,
    private readonly studioDataService: MarketingPageItemStudioDataService,
    private readonly trendingDataService: MarketingPageItemTrendingDataService,
    private readonly marketingEmailDataService: MarketingPageItemEmailDataService,
    private readonly catchUpPageItemDataService: CatchUpPageItemDataService,
    private readonly channelSpecificCatchUpPageItemDataService: ChannelSpecificCatchUpPageItemDataService,
    private readonly marketingPageItemVideoDataService: MarketingPageItemVideoDataService,
    private readonly marketingPageItemBarDataService: MarketingPageItemBarDataService,
    private readonly landscapePageItemDataService: LandscapePageItemDataService,
    private readonly categoryPageItemDataService: CategoryPageItemDataService,
    private readonly ondemandBannerPageItemDataService: OndemandBannerPageItemDataService
  ) {}

  public updatePageItem$(item: PageItem, pageVersionId: string, pageType: PageType, selectedTenant?: Tenant): Observable<unknown> {
    // eslint-disable-next-line sonarjs/max-switch-cases
    switch (item.type) {
      case 'PortraitTray':
      case 'TopTenTray':
        return this.carouselDataService.updateCarouselPageItem(
          item.id,
          mapCommonTrayDomainModelToApiModel(item, pageVersionId, selectedTenant?.id)
        );
      case 'CollectionTray':
        return this.carouselDataService.updateCarouselPageItem(
          item.id,
          mapDomainCollectionTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'BuiltIn':
        return this.builtInDataService.updateBuiltInPageItem(item.id, mapDomainBuiltInToApi(item, pageVersionId, selectedTenant?.id));
      case 'GenreTray':
        return this.genrePageItemDataService.updateGenrePageItem(item.id, mapDomainGenreTrayToApi(item, pageVersionId, selectedTenant?.id));
      case 'StudiosTray':
        return this.studioPageItemDataService.updateStudioPageItem(
          item.id,
          mapDomainStudiosTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'MarketingCta':
        return this.marketingCtaDataService.updateMarketingPageItemCta(item.id, mapDomainCtaToApi(item, pageVersionId, selectedTenant?.id));
      case 'MarketingUsp':
        return this.uspDataService.updateMarketingPageItemUsp(item.id, mapDomainUspToApi(item, pageVersionId, selectedTenant?.id));
      case 'RedeemGenericVoucherTray':
        return this.redeemGenericVoucherTrayDataService.updateMarketingGenericVoucherPageItem(
          item.id,
          mapDomainRedeemGenericVoucherTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'RedeemCtaTray':
        return this.redeemCtaTrayDataService.updateMarketingRedeemCtaPageItem(
          item.id,
          mapDomainRedeemCtaTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'AppLandingPageTray':
        return this.appLandingPageItemDataService.updateMarketingAppLandingPageItem(
          item.id,
          mapAppLandingPageItemDomainModelToApiModel(item, pageVersionId, selectedTenant?.id)
        );
      // CXB
      case 'MarketingHero':
        return this.marketingHeroDataService.updateMarketingHeroPageItem(
          item.id,
          mapDomainMarketingHeroToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'DetailedPageMarketingBanner':
        return this.marketingDetailPageItemDataService.updateMarketingDetailPageItem(
          item.id,
          mapDomainDetailedPageMarketingBannerToApiModel(item, pageVersionId, selectedTenant?.id)
        );
      case 'RedeemPartnerVoucherTray':
        return this.redeemPartnerVoucherTrayDataService.updateMarketingPartnerVoucherPageItem(
          item.id,
          mapDomainRedeemPartnerVoucherTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'RedeemUspTray':
        return this.redeemUspTrayDataService.updateMarketingBulletedUspPageItem(
          item.id,
          mapDomainRedeemUspTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'FaqTray':
        return pageType === PageType.redeem
          ? this.faqTrayDataService.updateMarketingFaqPageItem(
              item.id,
              mapDomainFaqTrayToApi(item, false, pageVersionId, selectedTenant?.id)
            )
          : this.targetedFaqTrayDataService.updateMarketingTargetedFaqPageItem(
              item.id,
              mapDomainFaqTrayToApi(item, true, pageVersionId, selectedTenant?.id) as CreateMarketingTargetedFaqPageItemApiModel
            );
      case 'SeasonTray':
        return this.seasonTrayDataService.updateTvSeasonPageItem(
          item.id,
          mapSeasonTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'SinglePhotoSeasonTray':
        return this.singlePhotoSeasonTrayDataService.updateSeasonPageItem(
          item.id,
          mapSinglePhotoSeasonTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'Hero':
        return this.heroDataService.updateHero(item.id, mapHeroTrayDomainModelToApiModel(item, undefined, selectedTenant?.id));
      // UXB
      case 'Recommendation':
        return this.recommendationPageItemDataService.updateRecommendationPageItem(
          item.id,
          mapRecommendationTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'MyFavouritesOnLiveTV': // AXB-71
      case 'LiveTVReminders': // AXB-84
      case 'ContinueWatchingTray': // AXB-79
      case 'MyListTray': // AXB-80
      case 'TVGuide': // AXB-78
      case 'WatchlistOnDemandTray':
      case 'PrimeVideoRecommendationsTray':
      case 'ContinueWatchingOndemandTray': //MYX-86
        return this.builtInDataService.updateBuiltInPageItem(
          item.id,
          mapBuiltInTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'TitleImagePortraitTray': // AXB-89
        return this.otherAppsDataService.updateOtherAppsPageItem(
          item.id,
          mapTitleImagePortraitTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'StreamingContentTray': // AXB-81
        return this.vodContentPageItemDataService.updateVodContentPageItem(
          item.id,
          mapStreamingContentTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'TopTenOnOSNPlusPosterArtTray': // AXB-82
        return this.topTenVodContentPageItemDataService.updateTopTenVodContentPageItem(
          item.id,
          mapTopTenOnOSNPlusPosterArtTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'CurrentlyOnTvTray': // AXB-73
        return this.currentlyOnTvPageItemDataService.updateCurrentlyOnTvPageItem(
          item.id,
          mapCurrentlyOnTVTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'ChannelLogoTray': // AXB-76
        return this.tvChannelLogoPageItemDataService.updateTvChannelLogoPageItem(
          item.id,
          mapChannelLogoTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'TopTenOnLiveTvTray': //AXB-75
        return this.topTenLiveTvPageItemDataService.updateTopTenLiveTvPageItem(
          item.id,
          mapTopTenOnLiveTVTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'AppsAndGamesRecommendedApps': // AXB-69
        return this.recommendedAppsPageItemDataService.updateRecommendedAppsPageItem(
          item.id,
          mapAppsAndGamesRecommendedAppsTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'AppsAndGamesInstalledApps': // AXB-70
        return this.installedAppsPageItemDataService.updateInstalledAppsPageItem(
          item.id,
          mapAppsAndGamesInstalledAppsTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'RecentlyWatchedTV':
        return this.recentlyWatchedTvPageItemDataService.updateRecentlyWatchedTvPageItem(
          item.id,
          mapRecentlyWatchedTVTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'HeroSpotlight':
        return this.spotlightPageItemDataService.updateSpotlightPageItem(
          item.id,
          mapHeroSpotlightTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'SearchTagsTray': //AXB-172
        return this.searchTagsPageItemDataService.updateSearchTagsPageItem(
          item.id,
          mapSearchTagsTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'ComingSoonForLiveTvTray': //AXB-74
        return this.upcomingLiveTvPageItemDataService.updateUpcomingLiveTvPageItem(
          item.id,
          mapComingSoonForLiveTvTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'FullscreenTray': // AXB-72
        return this.fullscreenPageItemDataService.updateFullscreenPageItem(
          item.id,
          mapFullscreenTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'BannersTrayWithCta': //AXB-86
        return this.bannersCtaPageItemDataService.updateBannersWithCtaPageItem(
          item.id,
          mapBannersTrayWithCtaTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'CarouselTray': // AXB-87
        return this.bannersPageItemDataService.updateBannersPageItem(
          item.id,
          mapNewCarouselTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'CarouselBannerTray': // AXB-88
        return this.collectionsPageItemDataService.updateCollectionsPageItem(
          item.id,
          mapCarouselBannerTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'UpcomingOnSpecificTvChannelTray': //AXB-83
        return this.channelSpecificUpcomingPageItemDataService.updateChannelSpecificUpcomingPageItem(
          item.id,
          mapUpcomingOnSpecificTvChannelTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'RecommendedChannelsTray': //AXB-194
        return this.recommendedChannelsPageItemDataService.updateRecommendedChannelsPageItem(
          item.id,
          mapRecommendedChannelsTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'MarketingBannerTray': //AXB-330
        return this.marketingBannerPageItemDataService.updateMarketingBannerPageItem(
          item.id,
          mapMarketingBannerTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'MarketingEmailBlocker':
        return this.marketingEmailBlockerPageItemDataService.updateMarketingEmailBlockerPageItem(
          item.id,
          mapMarketingEmailBlockerTrayDomainModelToApiModel(item, pageVersionId, selectedTenant?.id)
        );
      case 'SpotlightTray':
        return this.spotlightTrayDataService.updateMarketingSpotlightCtaPageItem(
          item.id,
          mapSpotlightTrayDomainModelToApiModel(item, pageVersionId, selectedTenant?.id)
        );
      case 'DeviceModuleTray':
        return this.deviceModuleTrayDataService.updateMarketingDeviceCtaPageItem(
          item.id,
          mapDomainDeviceModuleTrayToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'MarketingKids':
        return this.kidsDataService.updateMarketingPageItemKids(item.id, mapDomainKidsToApiModel(item, pageVersionId, selectedTenant?.id));
      case 'MarketingTrending':
        return this.trendingDataService.updateMarketingPageItemTrending(
          item.id,
          mapDomainTrendingToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'MarketingStudio':
        return this.studioDataService.updateMarketingPageItemStudio(item.id, mapDomainStudioToApi(item, pageVersionId, selectedTenant?.id));
      case 'MarketingEmailCollector':
        return this.marketingEmailDataService.updateMarketingPageItemEmail(
          item.id,
          mapDomainEmailCollectorToApi(item, pageVersionId, selectedTenant?.id)
        );
      case 'CatchUpTray':
        return this.catchUpPageItemDataService.updateCatchUpPageItem(
          item.id,
          mapCatchUpTrayDomainToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'ChannelSpecificCatchUpTray':
        return this.channelSpecificCatchUpPageItemDataService.updateChannelSpecificCatchUpPageItem(
          item.id,
          mapChannelSpecificCatchUpTrayDomainToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'MarketingVideoTray':
        return this.marketingPageItemVideoDataService.updateMarketingVideoPageItem(
          item.id,
          mapMarketingVideoTrayDomainModelToApiModel(item, undefined, selectedTenant?.id)
        );
      case 'MarketingBarTray':
        return this.marketingPageItemBarDataService.updateMarketingBarPageItem(
          item.id,
          mapMarketingBarTrayDomainModelToApiModel(item, undefined, selectedTenant.id)
        );
      case 'LandscapeTray':
        return this.landscapePageItemDataService.updateLandscapePageItem(
          item.id,
          mapLandscapeTrayDomainModelToApiModel(item, undefined, selectedTenant.id)
        );
      case 'OndemandCategoryTray':
        return this.categoryPageItemDataService.updateCategoryPageItem(
          item.id,
          mapCategoryTrayDomainModelToApiModel(item, undefined, selectedTenant.id)
        );
      case 'OndemandBannerTray':
        return this.ondemandBannerPageItemDataService.updateOndemandBannerPageItem(
          item.id,
          mapOndemandBannerTrayDomainModelToApiModel(item, undefined, selectedTenant.id)
        );
    }

    throw Error(`Unknown tray type: [${item}]`);
  }
}
